import { render } from "./KitchenOrderDetailsTable.vue?vue&type=template&id=8dbb11be"
import script from "./KitchenOrderDetailsTable.vue?vue&type=script&lang=js"
export * from "./KitchenOrderDetailsTable.vue?vue&type=script&lang=js"

import "./KitchenOrderDetailsTable.vue?vue&type=style&index=0&id=8dbb11be&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__